module.exports = __webpack_public_path__ + "static/media/RegistroContribuyente.ae320df7.jpg";